import {
    createColumnInput,
    createColumnInputNumber,
    createColumnSelect
} from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import store from "../../../../store";

export const callFeeType = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "FEE_TYPE", value: searchQuery });
export const callPaymentStatus = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "PAYMENT_STATUS", value: searchQuery });

export const createColumns = () => {
    const columns = [
        createColumnSelect({
            title: () => i18n.global.t("model.feeStatement.refType"),
            dataIndex: "refType.id",
            customRender: ({ record }) => <div>{record.refType?.value}</div>,
            inputProp: () => ({ list: callFeeType }),
            width: 100
        }),
        createColumnInput({
            title: () => i18n.global.t("model.feeStatement.feeCode"),
            dataIndex: "feeCode",
            align: "center"
        }),
        createColumnInput({ title: () => i18n.global.t("model.feeStatement.compCode"), dataIndex: "compCode", align: "center", width: 100 }),
        createColumnInput({ title: () => i18n.global.t("model.feeStatement.ref1"), dataIndex: "ref1", align: "center" }),
        createColumnInput({ title: () => i18n.global.t("model.feeStatement.ref2"), dataIndex: "ref2", align: "center" }),
        createColumnSelect({
            title: () => i18n.global.t("model.feeStatement.refStatus"),
            dataIndex: "refStatus.id",
            customRender: ({ record }) => {
                if (record.custom) {
                    return <div class="text-right text-bold">{record.custom} :</div>
                }
                return <div>{record.refStatus?.value}</div>
            },
            inputProp: () => ({ list: callPaymentStatus }),
            width: 120
        }),
        createColumnInputNumber({
            title: () => i18n.global.t("model.feeStatement.netAmount"),
            dataIndex: "netAmount",
            align: "right",
            allowPrecision: true,
            maxPrecision: 2,
            inputProp: () => ({
                allowPrecision: true,
                maxPrecision: 2
            }),
            width: 100
        })
    ];
    return columns;
};